var _g, _path, _ellipse, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayer5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 173,
    viewBox: "0 0 168 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2060_4177)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 58.4508,
    cy: 52.5502,
    r: 47.8797,
    fill: "#B5D8D4",
    fillOpacity: 0.75,
    stroke: "#4EA699",
    strokeWidth: 9.14224
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.1802,
    y: 106.208,
    width: 22.6258,
    height: 66.8491,
    rx: 11.3129,
    transform: "rotate(-45 85.1802 106.208)",
    fill: "#4EA699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.438 133.598L119.895 140.962C128.65 149.609 143.213 141.126 140.008 129.244L140.287 129.516C144.778 133.897 144.823 141.104 140.386 145.54C135.999 149.928 128.889 149.939 124.487 145.566L112.438 133.598Z",
    fill: "#4B978C"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.99944,
    height: 15.2717,
    rx: 3.99972,
    transform: "matrix(0.707107 -0.707107 -0.707107 -0.707107 93.9216 104.607)",
    fill: "#4EA699"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.653,
    y1: 103.578,
    x2: 126.318,
    y2: 120.243,
    stroke: "white",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.222,
    y1: 124.148,
    x2: 135.574,
    y2: 129.5,
    stroke: "white",
    strokeWidth: 2.61207,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.1703 19.2264C83.7037 22.4211 88.3638 26.9312 91.7379 32.3571C95.1119 37.783 97.0957 43.9572 97.5136 50.3329C97.9315 56.7087 96.7706 63.0891 94.1336 68.9089C91.4967 74.7288 87.4651 79.8086 82.396 83.6982C77.327 87.5878 71.3769 90.1673 65.0728 91.2081C58.7688 92.2489 52.3053 91.7189 46.255 89.6651C40.2047 87.6113 34.7542 84.097 30.3865 79.4336C26.0187 74.7702 22.8685 69.1016 21.2148 62.9299C22.5241 67.8163 27.0249 71.9898 32.2481 76.2092C37.4713 80.4286 44.0249 82.4898 46.5249 82.9898C49.0249 83.4898 58.7636 84.0485 63.7547 83.2245C68.7459 82.4004 73.4568 80.3582 77.4701 77.2786C81.4835 74.1991 85.2651 69.996 87.3529 65.3882C89.4407 60.7804 90.8635 52.0889 90.5327 47.041C90.2018 41.9931 90.0243 35.678 87.3529 31.3821C84.6815 27.0862 82.5513 21.7558 78.1703 19.2264Z",
    fill: "white",
    fillOpacity: 0.7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.265,
    cy: 24.2234,
    rx: 15.1941,
    ry: 10.4787,
    transform: "rotate(-2.6891 56.265 24.2234)",
    fill: "white",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.2809,
    cy: 30.8763,
    r: 4.02634,
    transform: "rotate(-2.6891 33.2809 30.8763)",
    fill: "white",
    fillOpacity: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2060_4177",
    x: 0,
    y: 0.099411,
    width: 143.762,
    height: 158.739,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.530833 0 0 0 0 0.530833 0 0 0 0 0.6125 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2060_4177"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2060_4177",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer5);
export default __webpack_public_path__ + "static/media/Layer_5.83659ae946621aaa2b7a6fd98b2dce43.svg";
export { ForwardRef as ReactComponent };